import { createContext, useCallback, useContext, useMemo, useRef } from 'react';

type WheelMotion = { isMoving: { current: boolean } };

const WheelMotionContext = createContext<WheelMotion | null>(null);

export const WheelMotionProvider = WheelMotionContext.Provider;

export const useWheelMotion = () => {
	const isMoving = useRef(false);

	const onScrollStart = useCallback(() => {
		isMoving.current = true;
	}, []);

	const onScrollEnd = useCallback(() => {
		isMoving.current = false;
	}, []);

	const value = useMemo<WheelMotion>(() => ({ isMoving }), []);

	return { value, onScrollStart, onScrollEnd };
};

export const useTapGuard = () => {
	const motion = useContext(WheelMotionContext);

	return useCallback(() => Boolean(motion?.isMoving.current), [motion]);
};

export default useTapGuard;
